module.exports = __webpack_public_path__ + "static/media/motor.54294262.png";